import { render, staticRenderFns } from "./CrmDocumentsTab.vue?vue&type=template&id=d493f4ec&scoped=true"
import script from "./CrmDocumentsTab.vue?vue&type=script&lang=ts"
export * from "./CrmDocumentsTab.vue?vue&type=script&lang=ts"
import style0 from "./CrmDocumentsTab.vue?vue&type=style&index=0&id=d493f4ec&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d493f4ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d493f4ec')) {
      api.createRecord('d493f4ec', component.options)
    } else {
      api.reload('d493f4ec', component.options)
    }
    module.hot.accept("./CrmDocumentsTab.vue?vue&type=template&id=d493f4ec&scoped=true", function () {
      api.rerender('d493f4ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crm/CrmDocumentsTab.vue"
export default component.exports